module.exports = __webpack_public_path__ + "static/media/1022927.978bac6a.png";